import { useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Brush,
} from "recharts";
import { numberFormat } from "../../../config/numberFormat";

export default function SalesBarChart({ data, totalAmount }) {

  if (totalAmount === 0) {
    return (
      <div style={styles.card}>
        <h3 style={styles.header}>Sale</h3>
        <p style={{ color: "#999", fontStyle: "italic" }}>No data available</p>
      </div>
    )
  }

  return (
    <div style={styles.card}>
      <h3 style={styles.header}>Sale: {numberFormat(totalAmount)}</h3>
      <div>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={data}
            margin={{ top: 20, right: 10, left: 40, bottom: 20 }}
          >
            <XAxis dataKey="name" />
            <YAxis tickFormatter={numberFormat} />
            <Tooltip formatter={(value) => numberFormat(value)} />
            <Legend />
            <Bar
              dataKey="sales"
              fill="#10b981"
              radius={[6, 6, 0, 0]}
              name="Sales"
            />
            <Brush dataKey="name" height={30} stroke="#10b981" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
const styles = {
  card: {
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    fontFamily: "sans-serif"
  },
  header: {
    marginBottom: 16,
    fontSize: 18,
    fontWeight: 600,
    color: "#10b981",
  },
};
